// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@5.5.1/+esm'

if (!customElements.get('section-hero')) {
  customElements.define(
    'section-hero',
    class ProductCarousel extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        this.els.slides.element.setAttribute(
          'data-custom-cursor-external-el',
          'carousel'
        )

        let timeout
        let mouseOver = false
        function clearNextTimeout () {
          clearTimeout(timeout)
        }
        function nextTimeout (e) {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            e.next()
          }, 6000)
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          loop: true,
          mode: 'snap',
          slidesPerView: 1,
          slides: '.car-Carousel_Slide',
          move: instance => {
            this.els.counter.element.innerText =
              instance.details().relativeSlide + 1
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide
              )
            })

            this.els.slide.elements.forEach((slide, index) => {
              if (index !== instance.details().relativeSlide) {
                slide
                  .querySelectorAll('[data-animate-scroll-el="letter"]')
                  .forEach(letterEl => {
                    letterEl.classList.remove(`ani-Scroll_Letter-animate`)
                  })

                slide
                  .querySelector('[data-animate-scroll-el="text"]')
                  ?.classList.remove(`ani-Scroll_Block-animate`)

                slide
                  .querySelector('[data-animate-scroll-el="buttons"]')
                  ?.classList.remove(`ani-Scroll_Block-animate`)
              }
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })

            this.els.slides.element.addEventListener('mouseover', () => {
              mouseOver = true
              clearNextTimeout()
            })
            this.els.slides.element.addEventListener('mouseout', () => {
              mouseOver = false
              nextTimeout(instance)
            })
            nextTimeout(instance)
          },
          slideChanged: instance => {
            nextTimeout(instance)

            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide
              )
            })

            this.els.slide.elements.forEach((slide, index) => {
              if (index === instance.details().relativeSlide) {
                let timeoutOffset = 800
                const letterEls = slide.querySelectorAll(
                  '[data-animate-scroll-el="letter"]'
                )

                letterEls.forEach(letterEl => {
                  timeoutOffset = timeoutOffset + 50

                  setTimeout(() => {
                    letterEl.classList.add(`ani-Scroll_Letter-animate`)
                  }, timeoutOffset)
                })

                const textEl = slide.querySelector(
                  '[data-animate-scroll-el="text"]'
                )
                if (textEl) {
                  timeoutOffset = timeoutOffset + 200

                  setTimeout(() => {
                    textEl.classList.add(`ani-Scroll_Block-animate`)
                  }, timeoutOffset)
                }

                const buttonsEl = slide.querySelector(
                  '[data-animate-scroll-el="buttons"]'
                )

                if (buttonsEl) {
                  timeoutOffset = timeoutOffset + 200

                  setTimeout(() => {
                    buttonsEl.classList.add(`ani-Scroll_Block-animate`)
                  }, timeoutOffset)
                }
              }
            })
          }
        })
      }
    }
  )
}
